window.Theme_FindInStore = ({
  sku,
  selectedSize,
  shopDomain,
  apiBaseUrl = 'https://shopifyleematthewsapp.testarc.com.au',
  sizeOptionIndex = 0,
  labels = {},
}) => {
  const hasStock = (stockStatus) => {
    return (
      stockStatus === true ||
      stockStatus === 1 ||
      stockStatus === '1' ||
      stockStatus === 'Y' ||
      stockStatus === 'y' ||
      stockStatus === 'YES'
    );
  };

  const normalizeLocation = (location) => {
    return {
      ...location,
      display_name:
        location.name || location.store_name || location.storeName || location.suburb || 'Store',
      display_phone: location.phone || location.telephone || location.tel || '',
      display_address_1: location.address_1 || location.address1 || '',
      display_suburb: location.suburb || location.city || '',
      display_state: location.state || location.province || '',
      display_postcode: location.postcode || location.zip || '',
    };
  };

  return {
    sku: sku || '',
    selectedSize: selectedSize || '',
    shopDomain: shopDomain || '',
    apiBaseUrl: (apiBaseUrl || '').replace(/\/$/, ''),
    sizeOptionIndex: Number(sizeOptionIndex) || 0,
    labels: {
      checking: labels.checking || '',
      sizeAvailableTemplate: labels.sizeAvailableTemplate || '',
      clickAndCollect: labels.clickAndCollect || '',
      noStoresFound: labels.noStoresFound || '',
    },
    loading: false,
    error: '',
    locations: [],

    async init() {
      this.bindVariantChange();
      await this.loadLocations();
    },

    bindVariantChange() {
      document.addEventListener('cascade:product:variantchange', (event) => {
        const nextVariant = event.detail && event.detail.variant ? event.detail.variant : null;
        if (!nextVariant) return;

        this.sku = nextVariant.sku || '';

        const variantOptions = Array.isArray(nextVariant.options) ? nextVariant.options : [];
        this.selectedSize =
          variantOptions[this.sizeOptionIndex] || this.selectedSize || '';

        this.loadLocations();
      });
    },

    formatSizeAvailability() {
      return this.labels.sizeAvailableTemplate.replace('[size]', this.selectedSize || '');
    },

    async loadLocations() {
      if (!this.sku) {
        this.error = this.labels.noStoresFound;
        return;
      }

      this.loading = true;
      this.error = '';

      try {
        const endpoint =
          `${this.apiBaseUrl}/api/2021-10/findinstore` +
          `?shop=${encodeURIComponent(this.shopDomain)}` +
          `&sku=${encodeURIComponent(this.sku)}`;

        const response = await fetch(endpoint);

        if (!response.ok) {
          throw new Error('Failed to fetch store availability');
        }

        const payload = await response.json();
        const nextLocations =
          payload && Array.isArray(payload.locations)
            ? payload.locations
                .filter((location) => hasStock(location.stock_status))
                .map((location) => normalizeLocation(location))
            : [];

        this.locations = nextLocations;

        if (!(payload && payload.success) || nextLocations.length === 0) {
          this.error = this.labels.noStoresFound;
        }
      } catch (_error) {
        this.error = this.labels.noStoresFound;
      } finally {
        this.loading = false;
      }
    },
  };
};
